<template>
  <div id="navegacao_mobile">
    <nav class="navegacao">
      <button class="menu_burguer" @click="estadoMenu">
        <img src="@/assets/imgs/icone_menu.svg" />
      </button>

      <div v-show="estadoMenuComp" class="icones-lateral">
        <a
          class="icone-lateral"
          href="javascript:void(0)"
          @click="showModal(true)"
        >
          <img
            src="@/assets/imgs/icone_busca.svg"
            alt="busca"
            class="icone_busca"
          />
        </a>
        <a
          :class="
            mostrarUfsComp
              ? 'icone-lateral icone-lateral-ativo'
              : 'icone-lateral'
          "
          href="javascript:void(0)"
          @click="estadoUfs"
          >{{ uf }}</a
        >
        <router-link
          :to="{ path: '/tabela-de-preco' }"
          class="icone-lateral"
          href="javascript:void(0)"
          @click="estadoOpcoes"
        >
          <img
            src="@/assets/imgs/icon-menu-filter.png"
            alt="tabela de preço"
            class="icone_busca"
          />
        </router-link>
        <a
          v-if="isNotifyVisible"
          class="icone-lateral notify"
          href="javascript:void(0)"
          @click="showNotificacoes(true)"
        >
          <div class="dot" v-if="showNotifyDot"></div>
          <img
            src="@/assets/imgs/icon-menu-notify.png"
            alt="notificações"
            class="icone_busca"
          />
        </a>
        <a
          class="icone-lateral"
          href="javascript:void(0)"
          @click="estadoOpcoes"
        >
          <img
            src="@/assets/imgs/icone_usuario.svg"
            alt="busca"
            class="icone_busca"
          />
        </a>
      </div>

      <selecao-uf-mobile :ativo="mostrarUfsComp" />

      <div class="opcoes-do-usuario" v-if="mostrarOpcoesComp">
        <a href="javascript:void(0)">
          <div class="item-c" @click="mostrarInputs = !mostrarInputs">
            Trocar Senha
            <img
              src="@/assets/imgs/icone_topo_branco.png"
              :style="mostrarInputs ? 'transform: rotate(180deg)' : ''"
            />
          </div>
          <form
            @submit="handleSubmit"
            class="senha"
            :style="mostrarInputs ? 'display: none' : ''"
          >
            <h4>
              Para trocar sua senha insira sua senha atual e em seguida a nova
              senha.
            </h4>
            <template v-if="message">
              <p class="success">{{ message }}</p>
            </template>
            <div class="linha">
              <div
                class="input"
                :class="
                  errors.has('senha') ||
                  (cErrors.inputError && cErrors.inputError.senhaAtual)
                    ? 'error'
                    : null
                "
              >
                <label>Senha Atual</label>
                <input
                  v-validate="'required'"
                  type="password"
                  name="senha"
                  autocomplete="new-password"
                  v-model="novasenha.senhaAtual"
                  placeholder="Digite sua senha atual"
                  required
                />
                <p class="text-error" v-if="errors.has('senha')">
                  Necessário informar sua senha atual
                </p>
              </div>
            </div>
            <div class="linha">
              <div
                class="input"
                :class="
                  errors.has('nova_senha') ||
                  (cErrors.inputError && cErrors.inputError.novaSenha)
                    ? 'error'
                    : null
                "
              >
                <label>Nova Senha</label>
                <input
                  v-validate="'required|min:8'"
                  name="nova_senha"
                  type="password"
                  autocomplete="new-password"
                  v-model="novasenha.novaSenha"
                  placeholder="Insira sua nova senha"
                  ref="nova_senha"
                />
                <p class="text-error" v-if="errors.has('nova_senha')">
                  Informe sua nova senha
                </p>
              </div>
            </div>
            <div class="linha">
              <div
                class="input"
                :class="
                  errors.has('conf_nova_senha') && fields.conf_nova_senha.dirty
                    ? 'error'
                    : null
                "
              >
                <label>Confirme Nova Senha</label>
                <input
                  v-validate="'required|min:8|confirmed:nova_senha'"
                  name="conf_nova_senha"
                  type="password"
                  autocomplete="new-password"
                  v-model="novasenha.confirmacao"
                  placeholder="Repita a senha nova"
                  data-vv-as="nova_senha"
                />
                <p
                  class="text-error"
                  v-if="
                    errors.has('conf_nova_senha') &&
                      fields.conf_nova_senha.dirty
                  "
                >
                  Senha não confere
                </p>
              </div>
            </div>
            <div class="linha">
              <div class="input">
                <button type="submit" class="botao" :disabled="validateButton">
                  <template v-if="!loading.changePassword"
                    >REDEFINIR SENHA</template
                  >
                  <img
                    class="spinner"
                    src="@/assets/imgs/spinner-white.svg"
                    v-else
                  />
                </button>
              </div>
            </div>
            <div class="errors" v-if="!!cErrors.status">
              <ul>
                <li v-for="(item, idx) in cErrors.messages" :key="idx">
                  {{ item }}
                </li>
              </ul>
            </div>
          </form>
        </a>
        <a @click="userLogout">Sair da conta</a>
      </div>

      <div
        :class="estadoMenuComp ? 'com_mascara' : 'com_mascara sem_mascara'"
        @click="estadoMenu"
      ></div>

      <ul
        class="nav-mobile"
        :class="{ hide: !estadoMenuComp }"
        ref="nav"
        @scroll="handleScroll"
      >
        <!-- First -->
        <li
          v-for="(menu1, idx1) in menus"
          :key="idx1"

          :class="{ 'nav-list': isObjectExists(menu1.sub), 'nav-active': accordionAberto == idx1 }"
        >
          <template v-if="isObjectExists(menu1.sub)">
            <p  @click  ="accordion(idx1, menu1)">
              {{ menu1.descricao }}
              <span v-if="isObjectExists(menu1.sub)" class="arrow">&#8250;</span>
            </p>
          </template>
          <template v-else>
            <router-link :to="{ path: resolvePath(menu1) }">
              <span @click="fecharMenu()">{{ menu1.descricao }}</span>
            </router-link>
          </template>
          <!-- Second -->
          <ul class="nav-mobile-items" v-if="isObjectExists(menu1.sub)">
            <li v-for="(menu2, idx2) in menu1.sub" :key="idx2" :class="{ 'nav-list': menu2.sub && menu2.sub.length > 0 }">
              <template>
                <router-link v-if="!!menu2.url" :to="{path: menu2.url}">
                  <span @click="fecharMenu()">{{ menu2.descricao }}</span>
                </router-link>
                <router-link v-else :to="{ path: resolvePath(menu2), params: { link: menu2.link_externo, categoria: menu2.slug, id: menu2.id, nome: menu2.label } }" >
                  <span @click="fecharMenu()">{{ menu2.descricao }}</span>
                </router-link>
              </template>
            </li>
          </ul>
        </li>
      </ul>
    </nav>

    <busca @emitMenu="fecharMenu()" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import env from '@/config/env';
import SelecaoUfMobile from '@/components/layout/header/SelecaoUfMobile.vue';
import Busca from '@/components/layout/header/Busca.vue';
import mixins from '@/helpers/mixins';

export default {
  name: 'NavegacaoPrincipal',
  mixins: [mixins],
  props: {},
  data: () => ({
    menuAtivo: false,
    mostrarUfs: false,
    mostrarOpcoes: false,
    mostrarInputs: false,
    menuClicado: null,
    accordionAberto: null,
    novasenha: {
      senhaAtual: '',
      nova: '',
      confirmacao: '',
    },
    estadoBotao: false,
    redirect: `${window.location.protocol}//${window.location.host}/_sys/portal-login/`,
  }),
  components: {
    SelecaoUfMobile,
    Busca,
  },
  computed: {
    ...mapGetters({
      uf: 'user/uf',
      menus: 'menu/categorias',
      categorias: 'categoria/getCategorias',
      loading: 'changePassword/loading',
      message: 'changePassword/message',
      cErrors: 'changePassword/errors',
      showNotify: 'notificacoes/showNotify',
      showNotifyDot: 'notificacoes/showButton',
    }),
    isNotifyVisible() {
      return this.showNotify && env.revista.canal === 6;
    },
    validateButton() {
      return (
        !!this.errors.items.length ||
        this.novasenha.senhaAtual === '' ||
        this.novasenha.novaSenha === '' ||
        this.novasenha.confirmacao === ''
      );
    },
    estadoMenuComp() {
      return this.menuAtivo;
    },
    mostrarUfsComp() {
      return this.mostrarUfs;
    },
    mostrarOpcoesComp() {
      if (this.mostrarOpcoes) this.clearAll();
      return this.mostrarOpcoes;
    }
  },
  methods: {
    ...mapActions({
      showModal: 'modal/showModal',
      menuHeader: 'menu/menuHeader',
      logout: 'auth/logout',
      changeUF: 'user/changeUF',
      trocarSenha: 'changePassword/changePassword',
      clearAll: 'changePassword/clearAll',
      showNotificacoes: 'notificacoes/showNotificacoes',
    }),
    async userLogout() {
      await this.logout();
      window.location.href = this.redirect;
    },
    async handleSubmit(e) {
      e.preventDefault();
      const response = await this.trocarSenha(this.novasenha);
      if (response) {
        this.novasenha = {
          senhaAtual: '',
          novaSenha: '',
          confirmacao: '',
        };
        this.$validator.reset();
      }
    },
    isObjectExists(value) {
      return value !== 'undefined' && value.length > 0;
    },
    accordion(index, item) {
      if(this.accordionAberto === index){
        this.accordionAberto = null;
        this.$router.push({ path: resolvePath(item) });
        this.fecharMenu();
      }
      else this.accordionAberto = index;
    },
    resolvePath(item){
      if(item.link_externo) {
        return `/redirect/${item.link_externo}`;
      }
      if(item.url){
        return `${item.url}`;
      }
      return `/categoria/${item.slug}`;
    },
    handleScroll(e) {
      const logo = document.querySelector('#logo-mob');
      if (e.target.scrollTop > 0) {
        logo.style.display = 'none';
      } else {
        logo.style.display = 'block';
      }
    },

    acaoBotaoUf(itemAtual) {
      this.changeUF(itemAtual);
      this.mostrarUfsComp();
    },
    estadoUfs() {
      this.mostrarUfs = !this.mostrarUfs;
    },
    estadoOpcoes() {
      this.mostrarOpcoes = !this.mostrarOpcoes;
    },
    estadoMenu() {
      this.menuAtivo = !this.menuAtivo;
      this.mostrarUfs = false;
      this.mostrarOpcoes = false;
    },
    fecharMenu() {
      this.menuAtivo = false;
    },
    abrirSubmenu(menu) {
      this.menuClicado = menu;
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.categorias) this.menuHeader(this.categorias);
    });
  }
};
</script>

<style scoped lang="scss">
@import '@/estilo/sass/_formulas.scss';
@import '@/estilo/sass/_cores.scss';

$espacamento: 10px;

#navegacao_mobile {
  display: none;

  .navegacao {
    padding-bottom: 0px;
    font-family: 'VivoType';
    font-weight: bold;

    & .menu_burguer {
      border: 0px;
      z-index: 10000;
      background: transparent;
      outline: none;
      outline-color: white;
      border-radius: 5px;
      padding: 10px;
      margin-right: 20px;
    }

    & .com_mascara {
      position: absolute;
      width: 100%;
      height: 120vh;
      overflow: hidden;
      z-index: -1;
      top: 0;
      left: 0;
      background: rgba(0, 0, 0, 0.9);
      transition: all 0.3s ease-in-out;
    }

    & .sem_mascara {
      height: 0px;
      background: rgba(0, 0, 0, 0);
    }

    & a, p {
      cursor: pointer;
      margin: 0px;
      padding: 0px;
      color: white;
      text-decoration: none;
      padding: 10px;
    }

    & .icones-lateral {
      animation: slider 0.25s linear;
      display: flex;
      flex-direction: column;
      position: absolute;
      right: 15px;
      align-items: center;
      margin-top: 24px;
      transition: all 0.2s ease-in-out;

      & .icone-lateral {
        display: flex;
        align-items: center;
        justify-content: center;
        @extend %gradiente_roxo;
        border-radius: 50px;
        width: calc((((100vw + 100vh) * 2) / 50) + 15px);
        height: calc((((100vw + 100vh) * 2) / 50) + 15px);
        line-height: 0px;
        z-index: 1;
        margin-bottom: 10px;
        transition: all 0.2s ease-in-out;

        & img {
          filter: brightness(100);
          max-width: 40px;
        }
      }

      & .icone-lateral-ativo {
        display: flex;
        align-items: center;
        justify-content: center;
        @extend %gradiente_amarelo;
        width: calc((((100vw + 100vh) * 2) / 50) + 15px);
        height: calc((((100vw + 100vh) * 2) / 50) + 15px);
        line-height: 0px;
        z-index: 1;
        margin-bottom: 10px;
      }

      & /deep/ .box-uf {
        @extend %nao-selecionavel;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 8vh;
        height: 8vh;
        padding: 0px;
        @extend %gradiente_twilight;
        border-radius: 5px;
        z-index: 1;

        & .selecao_uf {
          padding: 2.5vh 2.5vh !important;
          background: transparent;
        }
      }

      & /deep/ .seta-de-expansao {
        display: none;
      }
    }
    // Novo Menu Mobile 📱
    & .nav-mobile {
      @extend %flex;
      @extend %direction-column;
      @extend %justify-start;
      @extend %align-items-start;
      @extend %gradiente_twilight;
      padding: 0 10px 0 20px;
      padding-top: 75px;
      position: absolute;
      margin: 0px;
      top: 0;
      left: 0;
      // background: $cor_roxo;
      width: calc((((100vw + 100vh) * 2) / 8) + 0px);
      max-width: 70vw;
      min-height: calc(100vh - 65px);
      transition: all 0.3s ease-in-out;
      height: 100%;
      overflow-y: auto;
      overflow-x: none;

      & * {
        @extend %nao-selecionavel;
      }

      > li {
        position: relative;
        background: #ffffff22;
        font-size: calc((((100vw + 100vh) * 2) / 200) + 6px);
        z-index: 2000;
        width: calc((((100vw + 100vh) * 2) / 8) - 3vw);
        background: transparent;
        box-sizing: border-box;

        border-bottom: 1px solid hsla(0, 0%, 100%, 0.05);
        > a {
          display: flex;
          justify-content: space-between;
          align-content: center;
          color: white;
          padding: 10px;
          text-decoration: none;
          display: flex;
          justify-content: space-between;
          align-items: center;
          max-width: 100%;
          width: calc((((100vw + 100vh) * 2) / 8) - 20px);

          // max-width: calc(70vw - 30px);
          &:first-child {
            // margin-top: 10px;
          }

          &:hover {
            color: darken(white, 15%);
            background: hsla(0, 72%, 55%, 0.13);
          }
          .arrow {
            transform: rotate(90deg);
            color: white;
            opacity: 0.25;
            font-size: 12px;
            right: 5px;
            top: 15px;
            line-height: 0px;

            transition: all 0.3s ease-in-out;
          }
        }
        > ul {
          border-radius: 5px;
          background: hsla(0, 0%, 100%, 0.13);
          li {
            padding: 5px 0;
            border-bottom: 1px solid hsla(0, 0%, 100%, 0.05);

            a {
              display: flex;
              justify-content: space-between;
              align-content: center;
              color: white;
              padding: 5px;
              text-decoration: none;
              display: flex;
              justify-content: space-between;
              align-items: center;
              max-width: 100%;
              width: calc((((100vw + 100vh) * 2) / 8) - 20px);
              box-sizing: border-box;

              .arrow {
                transform: rotate(90deg);
                color: white;
                opacity: 0.25;
                font-size: 12px;
                right: 5px;
                top: 15px;
                line-height: 0px;

                transition: all 0.3s ease-in-out;
              }
            }
            > ul {
              > li {
                a {
                  width: 100%;
                  box-sizing: border-box;
                  .arrow {
                    transform: rotate(90deg);
                  }
                }
                > ul {
                  > li {
                    &:last-child {
                      border-bottom: none;
                    }
                  }
                }
              }
            }
          }
        }

        .nav-mobile-items {
          height: 0;
          overflow: hidden;

          li {
            padding: 5px 10px;
          }
        }
      }

      .nav-active {
        > .nav-mobile-items {
          animation: spawn 0.5s linear;
          display: block;
          padding: 5px 0;
          height: auto;
          color: #fff;
          border-radius: 5px;
          transition-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);
          transition: all 200ms;
          clear: both;
          float: left;
          width: 100%;

          > li {
            a {
              .arrow {
                transform: rotate(-90deg);
              }
            }
            > .nav-mobile-items {
              > li {
                background: transparent;
                > a {
                  .arrow {
                    transform: rotate(-90deg);
                  }
                }
                > .nav-mobile-items {
                  > li {
                    a {
                      .arrow {
                        transform: rotate(-90deg);
                      }
                    }
                  }
                }
              }
            }
          }

          > li.nav-active {
            background: #eb1e5a;
          }
        }
      }
    }

    & .nav_principal {
      @extend %flex;
      @extend %direction-column;
      @extend %justify-start;
      @extend %align-items-start;
      @extend %gradiente_twilight;
      padding: 0 10px 0 20px;
      padding-top: 75px;
      position: absolute;
      margin: 0px;
      top: 0;
      left: 0;
      // background: $cor_roxo;
      width: calc((((100vw + 100vh) * 2) / 8) + 0px);
      max-width: 70vw;
      min-height: calc(100vh - 65px);
      transition: all 0.3s ease-in-out;

      & * {
        @extend %nao-selecionavel;
      }
      li {
        position: relative;
        background: #ffffff22;
        font-size: calc((((100vw + 100vh) * 2) / 200) + 6px);
        z-index: 2000;
        padding: 5px 0;
        width: 100%;
        width: calc((((100vw + 100vh) * 2) / 8) - 3vw);
        background: transparent;
        a {
          color: white;
          text-decoration: none;
          padding: 10px 10px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          max-width: 100%;
          // width: calc((((100vw + 100vh) * 2) / 8) - 20px);
          // max-width: calc(70vw - 30px);
          &:hover {
            color: darken(white, 15%);
          }
        }
      }
      li.list {
        a {
          & .arrow {
            color: white;
            opacity: 0.25;
            font-size: 12px;
            right: 5px;
            top: 15px;
            line-height: 0px;

            transition: all 0.3s ease-in-out;
          }
        }

        & .items {
          height: 0px;
          overflow: hidden;
          display: none;
        }
      }

      .active {
        background: transparent !important;
        a {
          span {
            transform: rotate(-180deg);
          }
        }
        & > .items {
          animation: spawn 0.5s linear;
          display: block !important;
          background: #ffffff22;
          padding: 0px;
          height: auto;
          color: #fff;
          border-radius: 5px;
          transition-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);
          transition: all 200ms;
          clear: both;
          float: left;
          width: 100%;
          a {
            padding: 17px;

            &:hover {
              background-color: #3f5d79;
              color: #fff;
              transition: 300ms all;
            }
          }
        }
      }

      // & .menu-rodape {
      //   display: flex;
      //   align-items: center;

      //   & .busca {
      //     padding: 12px 10px;
      //     margin-right: 10px;

      //     & img {
      //       max-width: 40px;
      //     }
      //   }
      // }
    }

    & .hide {
      left: -100%;
    }

    & .opcoes-do-usuario {
      @extend %gradiente_twilight;
      color: white;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 5001;
      height: calc(100vh - 160px);
      padding: 85px 10px 75px 30px;
      margin: 0px;
      width: 100%;
      max-width: calc(70% - 10px);

      & a, p {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        font-size: calc((((100vw + 100vh) * 2) / 200) + 6px);
        // margin-bottom: calc((((100vw + 100vh) * 2) / 200) + 6px);
        width: 100%;
        transition: all 0.2s ease-in-out;
        padding: 15px 0;
        border-bottom: 1px solid rgba(255, 255, 255, 0.05);

        & .item-c {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          width: 100%;

          & img {
            opacity: 0.25;
            width: 10px;
            height: 10px;
            margin-right: 10px;
            transform: rotate(0deg);
          }
        }

        & .senha {
          display: flex;
          flex-direction: column;
          width: 100%;
          animation: fade 0.2s ease-in-out;
          animation-iteration-count: 1;
          margin: 15px 0 5px;

          & .error {
            & input {
              border-color: #e47a8c !important;
              color: #e47a8c !important;
            }

            & p {
              color: #e47a8c;
              font-size: 9px;
              margin: 5px;
            }
          }

          .errors {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 280px;
            max-width: 280px;

            & ul {
              list-style: none;
              width: 100%;
              margin: 0;
              padding: 0;

              & li {
                color: #e47a8c;
                font-size: 12px;
                margin: 5px;
              }
            }
          }

          & .botao {
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            font-family: 'VivoType';
            font-weight: bold;
            background: $cor_roxo;
            position: relative;
            border: none;
            width: 100%;
            height: 36px;
            padding: 0;
            border-radius: 5px;
            color: white;
            outline: none;
            margin-top: -2px;

            &:hover {
              @extend %gradiente_twilight;
            }

            &:disabled {
              background: rgba(white, 0.2) !important;
              box-shadow: none !important;
            }
          }

          & h4 {
            font-family: 'OpenSans';
            color: white;
            font-weight: 200;
            font-size: calc((((100vw + 100vh) * 2) / 300) + 5px);
            margin: 0px;
            margin-bottom: 24px;
            opacity: 0.5;
          }

          & p.success {
            text-align: center;
            font-size: 12px;
            color: $cor_verde;
            width: 100%;
            margin-bottom: 30px;
            margin-top: -20px;
          }

          & .linha {
            display: flex;
            width: 100%;
            // max-width: 200px;
            margin-bottom: 18px;

            & .input {
              display: flex;
              flex-direction: column;
              position: relative;
              width: 95%;

              & label {
                color: white;
                font-family: 'OpenSans';
                position: absolute;
                font-size: calc((((100vw + 100vh) * 2) / 450) + 3px);
                top: 0;
                left: 0;
                margin-top: -5%;
              }

              & input[type] {
                -webkit-appearance: none;
                -moz-appearance: none;
                appearance: none;
              }

              & input {
                -webkit-appearance: none;
                font-size: calc((((100vw + 100vh) * 2) / 200) + 6px);
                font-weight: bold;
                max-height: 20px;
                color: white;
                font-family: 'VivoType';
                width: calc(100% - 22px);
                padding: 8px 10px;
                border: 1px solid rgba(white, 0.1);
                border-radius: 5px;
                outline: none;
                background: rgba(white, 0.1);
              }

              & input:-webkit-autofill,
              input:-webkit-autofill:hover,
              input:-webkit-autofill:focus,
              input:-webkit-autofill:active {
                background-color: white !important;
                color: #660099 !important;
                -webkit-text-fill-color: #660099 !important;
                -webkit-box-shadow: 0 0 0 30px white inset !important;
              }

              & input:-internal-autofill-selected {
                background-color: white !important;
                color: #660099 !important;
                -webkit-box-shadow: 0 0 0 30px white inset !important;
              }

              & ::placeholder {
                color: rgba(white, 0.5);
                font-size: calc((((100vw + 100vh) * 2) / 300) + 6px);
                font-weight: 200 !important;
              }

              & .spinner {
                width: 40px;
                height: auto;
                opacity: 1;
                fill: #609;
              }
            }
          }
        }
      }
    }
  }
}

@keyframes spawn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes slider {
  0% {
    margin-right: -20vw;
  }
  100% {
    margin-right: 0px;
  }
}

@keyframes fade {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@media all and (min-width: 300px) and (max-width: 1160px) {
  #navegacao_mobile {
    display: block;
  }
}

@media all and (max-width: 400px) {
  .nav-mobile {
    width: calc((((100vw + 100vh) * 2) / 8) - 0vw) !important;
  }
}

@media all and (min-width: 680px) and (max-width: 1160px) {
  #navegacao_mobile {
    .navegacao {
      & .menu_burguer {
        padding: 15px;
        margin-right: 30px;

        & img {
          width: 30px;
          height: auto;
        }
      }

      & .icones-lateral {
        & .icone-lateral {
          & img {
            width: 30px;
          }
        }

        & /deep/ a {
          font-size: 26px;
        }
      }

      & .nav_principal {
        padding: 0 20px 0 40px;
        padding-top: 100px;

        & span {
          top: 20px !important;
        }
      }

      & .opcoes-do-usuario {
        padding: 120px 50px 75px 50px;
        max-width: calc(70% - 140px);

        & a, p {
          font-size: 22px;
          padding: 20px 0;

          & .item-c {
            & img {
              opacity: 0.25;
              width: 14px;
              height: 14px;
              margin-right: 0px;
            }
          }

          & .senha {
            margin: 25px 0 15px;

            & .botao {
              font-size: 16px;
              height: 46px;
            }

            & h4 {
              font-size: 16px;
              margin-bottom: 35px;
            }

            & .linha {
              margin-bottom: 24px;

              & .input {
                display: flex;
                flex-direction: column;
                position: relative;
                width: 90%;

                & label {
                  font-size: 11px;
                }

                & input {
                  font-size: 16px;
                  max-height: 30px;
                  padding: 13px 10px;
                }

                & ::placeholder {
                  font-size: 16px;
                }
              }
            }
          }
        }
      }
    }
  }
}

.notify {
  position: relative;

  img {
    z-index: 1;
  }
  .dot {
    height: 10px;
    width: 10px;
    position: absolute;
    background: red;
    border-radius: 50%;
    right: 16px;
    top: 16px;
    z-index: 3;

    &::before {
      content: '';
      height: 16px;
      width: 16px;
      position: absolute;
      background: red;
      border-radius: 50%;
      top: -3px;
      right: -3px;

      -webkit-animation: ping 1.4s ease-in-out infinite both;
      animation: ping 1.4s ease-in-out infinite both;
    }
  }
}

@-webkit-keyframes ping {
  0% {
    -webkit-transform: scale(0.2);
    transform: scale(0.2);
    opacity: 1;
  }
  80% {
    -webkit-transform: scale(1.2);
    transform: scale(1.2);
    opacity: 0;
  }
  100% {
    -webkit-transform: scale(2.2);
    transform: scale(2.2);
    opacity: 0;
  }
}
@keyframes ping {
  0% {
    -webkit-transform: scale(0.2);
    transform: scale(0.2);
    opacity: 1;
  }
  80% {
    -webkit-transform: scale(1.2);
    transform: scale(1.2);
    opacity: 0;
  }
  100% {
    -webkit-transform: scale(2.2);
    transform: scale(2.2);
    opacity: 0;
  }
}
</style>
